import { getEvents, getEvent, postEvent, putEvent, deleteEvent } from 'actions'

export const fetchEvents = async (params) => {
  const res = await getEvents(params)
  return {
    type: 'GET_EVENTS_SUCCESS',
    data: res.events
  }
}

export const fetchEvent = async (id) => {
  const res = await getEvent(id)
  return {
    type: 'GET_EVENT_SUCCESS',
    data: res.event
  }
}

export const createEvent = async (payload) => {
  const res = await postEvent(payload)
  return {
    type: 'CREATE_EVENT_SUCCESS',
    data: res.event
  }
}

export const updateEvent = async (id, payload) => {
  const res = await putEvent(id, payload)
  return {
    type: 'UPDATE_EVENT_SUCCESS',
    data: res.event
  }
}

export const removeEvent = async (id) => {
  await deleteEvent(id)
  return {
    type: 'DELETE_EVENT_SUCCESS',
    data: { id }
  }
}
